<script>
export default {
  name: 'BillSendDetail',
  props: {
    infoPrepayment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showBillBox: false,
    };
  },
  methods: {
    changeBillBoxShow() {
      this.showBillBox = !this.showBillBox;
    },
  },
};
</script>

<template>
  <div style="border: 1px solid #f2f2f2; padding: 20px 0; margin-bottom: 36px">
    <div class="prepay-box">
      <div class="prepay-left">
        <img src="../../../assets/imgs/prepay-send.png" style="width: 80px; margin: 0 10px" />
        <span>
          <span style="font-size: 14px; font-weight: 400">Send shipping</span>
          <br />
          <span style="font-size: 13px; font-weight: 400; color: #999999">
            {{ infoPrepayment.ctn }} Packages / Each 50lb
          </span>
        </span>
      </div>
      <div class="prepay-right">
        <div>
          <span style="font-size: 18px; font-weight: 700">${{ infoPrepayment.fee }}</span>
          <br />
          <i-button type="text" style="color:#66cccc; padding: 0;" @click="changeBillBoxShow()">Show details</i-button>
        </div>
      </div>
    </div>
    <div v-if="showBillBox" class="bill-box">
      <div v-for="item in infoPrepayment.details" :key="item.itemName" class="prepay-box bill-item">
        <div class="prepay-left">{{ item.itemName }}</div>
        <div class="prepay-right">${{ item.itemFee }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.prepay-box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  .prepay-left {
    display: flex;
    align-items: center;
  }
  .prepay-right {
    display: flex;
    align-items: center;
    text-align: right;
  }
}
.bill-box {
  margin: 20px 40px;
  background: #fbfbfb;
  .bill-item {
    height: 40px;
    margin: 0 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .bill-item:last-of-type {
    border-bottom: none;
  }
}
</style>
